var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeading2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81152 13.6V12.144L11.2595 8.368C12.0755 7.088 12.4915 5.984 12.4915 5.04C12.4915 4.064 12.2675 3.664 11.7395 3.664C11.0995 3.664 10.8595 4.144 10.8275 5.456H8.93952C8.97152 3.088 9.85152 2 11.7715 2C13.5955 2 14.5555 3.024 14.5555 4.96C14.5555 5.984 14.3795 6.704 13.9315 7.568C13.6115 8.192 13.6115 8.192 12.5715 9.776L11.1795 11.904H14.5235V13.6H8.81152Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 13.6V2.17603H3.2642V6.99203H5.4882V2.17603H7.5522V13.6H5.4882V8.68803H3.2642V13.6H1.2002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading2);
export default __webpack_public_path__ + "static/media/heading2.2df4aa032af39db88130e7e31846e5e0.svg";
export { ForwardRef as ReactComponent };